import i18n from '@/i18n'
import {makeStep} from "../../utils";
import {requireAssetWithFallback} from "@/utils";
import {_} from 'vue-underscore';

const splitType = (curtainTemplate, curtainType) => {
  const availableSplitTypes = curtainTemplate.available_split_types
    && _.filter(curtainTemplate.available_split_types, splitType => splitType !== 'unequal')
  if (!availableSplitTypes) {
    return null
  }

  return {
    id: 'split_type',
    name: i18n.t('components.stepper.splitType.title'),
    type: 'card',
    default: '',
    choices: availableSplitTypes.map(availableSplitType => ({
      title: i18n.t(`enums.SplitType.${availableSplitType}.title.${curtainType}`),
      value: availableSplitType,
      imgSrc: requireAssetWithFallback(`images/split_type/${availableSplitType}.png`),
      infoDialogTitle: i18n.t(`enums.SplitType.${availableSplitType}.informTitle`),
      infoDialogText: i18n.t(`enums.SplitType.${availableSplitType}.informText.${curtainType}`),
      dialogHeader: i18n.t(`components.inform.splitDialogHeader`),
    }))
  }
}

export default (curtainTemplate, curtainType) => {
  const stepQuestions = [
    splitType(curtainTemplate, curtainType),
  ]
  return makeStep(stepQuestions, i18n.t('components.stepper.splitType.title'))
}
